/**
 * The closing arm of an exhaustive switch. A new member of a closed vocabulary
 * fails the build here rather than reaching the office as a blank line, which
 * is the whole point: every state this dashboard can be handed has copy.
 */
export function assertNever(value: never, context: string): never {
  throw new Error(`${context}: unhandled ${String(value)}`);
}
